import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "logout-button" }

import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { onMounted } from "vue";
import { showDialog } from 'vant';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();
const store = useStore();

const handleLogout = () => {
  showDialog({
    title: '提示',
    message: '确定要退出登录吗？',
    showCancelButton: true,
  }).then(() => {
    // 清除用户登录信息
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('currentNavbar');
    store.dispatch('user/logout');
  }).catch(() => {
    // 取消退出
  });
};

onMounted(() => {
  // 可以在这里添加初始化逻辑
});

return (_ctx: any,_cache: any) => {
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomTitleBar, { title: "设置" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_cell_group, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_cell, {
            title: "聊天设置",
            "is-link": ""
          }),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "br-16" }, null, -1)),
          _createVNode(_component_van_cell, {
            title: "安全设置",
            "is-link": ""
          }),
          _createVNode(_component_van_cell, {
            title: "隐私设置",
            "is-link": ""
          }),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "br-16" }, null, -1)),
          _createVNode(_component_van_cell, {
            title: "通知设置",
            "is-link": ""
          }),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "br-16" }, null, -1)),
          _createVNode(_component_van_cell, {
            title: "注销账号",
            "is-link": ""
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_button, {
          round: "",
          type: "danger",
          onClick: handleLogout
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode(" 退出登录 ")
          ])),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})